import type { PhotoLocale } from "@/locales/fr/photo";

import { EPhotoSource } from "@/domains/site/site-photo-source.types.ts";
import { ESitePhotoOcrResultStatus } from "@/types/backoffice/dto/photo/site-photo-dto.ts";

const ocrResult: Record<ESitePhotoOcrResultStatus, string> = {
  [ESitePhotoOcrResultStatus.NOT_DONE]: "Not done",
  [ESitePhotoOcrResultStatus.PENDING]: "Pending",
  [ESitePhotoOcrResultStatus.PROCESSING]: "Processing",
  [ESitePhotoOcrResultStatus.OK]: "Ok",
  [ESitePhotoOcrResultStatus.KO]: "Ko",
  [ESitePhotoOcrResultStatus.FAILED]: "Failure",
};

const source: Record<EPhotoSource, string> = {
  [EPhotoSource.UNKNOWN]: "Unknown",
  [EPhotoSource.VOLTINSTALL_CAMERA]: "Taken with the camera",
  [EPhotoSource.VOLTINSTALL_GALLERY]: "Selected from the gallery",
};

const photoLocale: PhotoLocale = {
  photos: {
    upload: {
      modalTitle: "Upload photos",
      photoTypeRef: "Photo type",
    },
    uploadLabel: "Upload",
    size: {
      large: "Large",
      medium: "Medium",
      small: "Small",
    },
    gallery: "Gallery",
    noThumbnailType: "No thumbnail, click to see {photoName}",
    filter: {
      date: "Date",
      photoType: "Photo Type",
    },
    noPhotos: "No photos",
    noPhotosDesc: "This site has no photos, please come back later",
    modulator: {
      label: "Modulator Identifier",
      columnDetail: "ID column from table CS_MODULATOR",
    },
    ocrResultStatus: "Document status",
    updateOcrStatusDialog: {
      title: "Update document status",
      currentStatusLabel: "Current status:",
      newStatusLabel: "New status",
      menuEditLabel: "Update document status",
      cancel: "Cancel",
      save: "Save",
    },
    ocrResult: ocrResult,
    source: source,
    geolocation: {
      latitude: "Latitude",
      longitude: "Longitude",
      openstreetmap: "Openstreetmap",
    },
  },
};

export default photoLocale;
